import Star from '../star';

export function generatingStars(data) {
  const r = data.rating;
  return [...Array(5).keys()].map((v) => {
    let starValue = 1;
    if (v >= r) {
      starValue = 0;
    } else if (r > v && r - v < 1) {
      starValue = r - v;
    }
    return <Star key={v} value={starValue} />;
  });
}

export default generatingStars;
